<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Создание') }}</h1>
    <div class="my-organization">
      <div class="blanks-pg create bgw-pdg-20">
        <v-form
          ref="form"
          lazy-validation
          @submit.prevent="createProductionBso"
        >
          <div class="form-group">
            <div class="quota-fields">
              <div class="quota-field" :class="{ invalid: $v.production_bso.strictReportingFormType.$error }">
                <label>{{ $t('Тип БСО') }}:</label>
                <div class="select-def">
                  <v-select
                    :items="bsoTypes"
                    item-value="id"
                    item-text="transCorrectName"
                    v-model="production_bso.strictReportingFormType"
                    outlined
                    dense
                    required
                    clearable
                    @change="numberMinMaxLengthHandler"
                  />
              </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="quota-fields">
              <!--Стартовый номер-->
              <div
                class="quota-field field-sm"
                :class="{ invalid: ($v.production_bso.startNumber.$error || !$v.production_bso.startNumber.minLength || !$v.production_bso.startNumber.maxLength) || production_bso.startNumber > production_bso.endNumber }"
              >
                <label>{{ $t('Стартовый номер') }}:</label>
                <v-text-field
                  v-model="production_bso.startNumber"
                  type="number"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
                <small class="helper-text gray">
                  ({{ $t('формат ввода') }} <span>{{ numberFormat }}</span>) <br>
                </small>
                <small
                  v-if="!$v.production_bso.startNumber.minLength || !$v.production_bso.startNumber.maxLength"
                  class="helper-text invalid"
                >
                  {{ $t('Длина поля должна быть равна') }}
                  {{ $v.production_bso.startNumber.$params.minLength.min }} {{ $t('символов') }}
                </small>
                <small
                  v-if="production_bso.startNumber > production_bso.endNumber"
                  class="helper-text invalid"
                >
                  {{ $t('Стартовый номер должен быть меньше или равен конечному') }} <br>
                </small>
              </div>
              <!--Конечный номер-->
              <div
                class="quota-field field-sm"
                :class="{ invalid: $v.production_bso.endNumber.$error || !$v.production_bso.endNumber.minLength || !$v.production_bso.endNumber.maxLength }"
              >
                <label>{{ $t('Конечный номер') }}:</label>
                <v-text-field
                  v-model="production_bso.endNumber"
                  type="number"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
                <small class="helper-text gray">
                  ({{ $t('формат ввода') }} <span>{{ numberFormat }}</span>) <br>
                </small>
                <small
                  v-if="!$v.production_bso.endNumber.minLength || !$v.production_bso.endNumber.maxLength"
                  class="helper-text invalid"
                >
                  {{ $t('Длина поля должна быть равна') }}
                  {{ $v.production_bso.endNumber.$params.minLength.min }} {{ $t('символов') }}
                </small>
              </div>
            </div>
          </div>
          <!--Цена-->
          <div class="form-group">
            <div class="quota-fields">
              <div class="quota-field" :class="{ invalid: $v.production_bso.blankPrice.$error }">
                <label>{{ $t('Цена (в сомах)') }}:</label>
                <v-text-field
                  v-model="production_bso.blankPrice"
                  type="number"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
              </div>
              <div class="quota-field field-sm datepicker-main" :class="{ invalid: $v.production_bso.makeDate.$error }">
                <label>{{ $t('Дата изготовления') }}:</label>
                <div class="form-date">
                  <v-icon class="date-icon">date_range</v-icon>
                  <VueCtkDateTimePicker
                    v-model="production_bso.makeDate"
                    format="DD.MM.YYYY"
                    formatted="LL"
                    :onlyDate="true"
                    :label="''"
                    :autoClose="true"
                    :noButton="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--Кнопки действии-->
          <div class="form-action text-center">
            <button
              class="btn btn-default blue"
              type="submit"
            >
              {{ $t('Сохранить') }}
            </button>
            <button
              class="btn btn-default gray"
              type="button"
              @click="onCancel"
            >
              {{ $t('Отмена') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import BSO from '@/model/bso'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    breadcrumbs: [],
    bsoTypes: [],
    production_bso: {},
    minMaxLength: 6,
    numberFormat: null,
    rules: {
      production_bso: {
        strictReportingFormType: { required },
        startNumber: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(6)
        },
        endNumber: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(6)
        },
        blankPrice: { required },
        makeDate: { required }
      }
    }
  }),
  validations () {
    if (this.production_bso.strictReportingFormType) {
      this.rules.production_bso.startNumber = {
        minLength: minLength(this.minMaxLength),
        maxLength: maxLength(this.minMaxLength)
      }
      this.rules.production_bso.endNumber = {
        minLength: minLength(this.minMaxLength),
        maxLength: maxLength(this.minMaxLength)
      }
    }
    return this.rules
  },
  mounted () {
    this.getBsoFormData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные для формы
    getBsoFormData () {
      this.setLoading(true)
      BSO.getBsoFormData()
        .then((response) => {
          this.bsoTypes = response.data.refStrictReportingFormType
          this.generateBreadcrumbs()
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
    },
    // создание БСО
    createProductionBso () {
      if (!this.validateForm()) {
        return
      }

      if (this.production_bso.startNumber > this.production_bso.endNumber) {
        this.$noty.error(this.$i18n.t('Стартовый номер должен быть меньше или равен конечному'), {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
        return
      }

      this.setLoading(true)

      BSO.createProductionBso(this.production_bso).then((response) => {
        // console.log('createProductionBso', response)
        this.$router.push({
          name: 'bso-list'
        })
        this.setLoading(false)
      }).catch((error) => {
        console.log(error)
        this.setLoading(false)
      })
    },
    // получаем значение для минимальной и максимальной длины полей (стартовый и конечный номер)
    numberMinMaxLengthHandler (value) {
      this.bsoTypes.forEach(element => {
        if (element.id === value) {
          this.minMaxLength = element.count_number
        }
      })
      console.log(this.minMaxLength)
      this.numberFormat = '1'.padStart(this.minMaxLength, '0')
      console.log(this.numberFormat)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Список БСО'),
          disabled: false,
          href: '/bso-list'
        },
        {
          text: this.$i18n.t('Создание'),
          disabled: true
        }
      ]
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'bso-list'
      })
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>

</style>
